<script setup lang="ts">
const route = useRoute()
</script>

<template>
  <NuxtLink
    class="z-1 self-end text-sm text-(--foreground,var(--color-seagreen-50)) xs:text-base"
    :to="route.path"
    :replace="true"
  >
    Nullstill filtre
  </NuxtLink>
</template>
